export const environment = {
  production: true,
  api: 'https://api.auditorias.dev.globaluy.com',
  url: 'https://auditorias.bo.dev.globaluy.com',
  googleClientId:
    '310009689292-1gevnsho09jo4ntrp1eesqbvv6ssig5m.apps.googleusercontent.com',
  googleClientSecret: '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',
  googleMapsApiKey: 'AIzaSyApZ3ukkBKXt16oMxwfOSjO1OLgx_ohLM0',
};
